import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getUserRole } from "../services/userRoleService";
import { USER_ROLES } from "../constants/appConstants";

export function useUserRole() {
  const { user } = useAuth();
  const [role, setRole] = useState(USER_ROLES.VIEWER);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      if (!user?.uid) {
        if (active) {
          setRole(USER_ROLES.VIEWER);
          setLoading(false);
        }
        return;
      }
      setLoading(true);
      try {
        const r = await getUserRole(user.uid);
        if (active) setRole(r || USER_ROLES.VIEWER);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [user?.uid]);

  // "owner" is phased as default for signed-in users without elevated role.
  const effectiveRole = user && role === USER_ROLES.VIEWER ? "owner" : role;

  return { role, effectiveRole, loading };
}

